module.exports = __webpack_public_path__ + "static/media/premium.6d8416c1.svg";